import objectFitImages from 'object-fit-images'

document.addEventListener('turbolinks:load', () => {
  objectFitImages('img.js-ofi')
})
